import { Container } from "react-bootstrap";
import '../Commons.scss'

export default function Footer() {
    return (
        <div className="footer py-5">
            <Container className="text-start">
                <p>TCG Arena is not affiliated with, endorsed, sponsored, or specifically approved by any TCG playable on it. No TCGs are hosted on this platform, the Game tab is only here to offer you a quick acces to the link hosting files for those games. If you have made files using the game builder and want a link to them on this page let me know on Discord.</p>
                <p>This is a free educational tool, it does not include tournaments or rankings. All features are accessible for free and are not intended for commercial use.</p>
                <p>This app is still a work in progress, if you have issues or suggestions, feel free to reach me on Discord.</p>
                <p>Current version 1.15.3</p>
                <p>App icon by Md Tanvirul Haque, other icons by Freepik. Homepage image by Zishan Liu. Cards 1 and 5 from the homepage by wia.</p>
            </Container>
        </div>
    )
}